import React from 'react'
import styles from './headerYellowSpecific.module.scss'
import { locale } from '../../../../src/common/i18n'
import WebIcon from './assets/web.svg'

interface Props {
  esPath: string
  caPath: string
}

export default function LanguageSelector({ esPath, caPath }: Props) {
  return (
    <div className={styles.languages}>
      <WebIcon className={styles.web_icon} />
      {locale === 'es' ? (
        <span className={styles.langActive}>ESP</span>
      ) : (
        <a
          href={
            esPath
              ? `${process.env.GATSBY_WEB_URL_es}${esPath}`
              : `${process.env.GATSBY_WEB_URL_es}`
          }
          className={styles.langDis}>
          ESP
        </a>
      )}
      /
      {locale === 'ca' ? (
        <span className={styles.langActive}>CAT</span>
      ) : (
        <a
          href={
            caPath
              ? `${process.env.GATSBY_WEB_URL_ca}${caPath}`
              : `${process.env.GATSBY_WEB_URL_ca}`
          }
          className={styles.langDis}>
          CAT
        </a>
      )}
    </div>
  )
}
